import React from "react";

import { WidgetType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { MessageBoxFullPageDialog } from "@src/domains/WidgetLibrary/MessageBox/MessageBoxFullPageDialog";
import { MessageBoxPreview } from "@src/domains/WidgetLibrary/MessageBox/MessageBoxPreview";
import { useSelector } from "@src/store";
import {
  getLibraryMessageBoxes,
  getLibraryMessageBoxPopups,
  getLibraryMessageBoxSlideOuts,
} from "@src/store/slices/widgets/selectors";
import { GlobalStylesMessageBoxVariantList } from "@src/types/widgetVariants";

export const MessageBoxOverview = () => {
  const widgets = useSelector(getLibraryMessageBoxes).filter((widget) => {
    const variant = widget.config.desktop?.variant;
    return (
      // @ts-ignore - GlobalStylesMessageBoxVariantList is the now supported variants
      variant && GlobalStylesMessageBoxVariantList.includes(variant)
    );
  });

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"flex-end"}
      rowSpacing={2}
      columnSpacing={2}
    >
      <Grid item container direction={"row"} rowSpacing={4} columnSpacing={4}>
        {widgets.map((widget) => (
          <MessageBoxPreview key={widget.id} widget={widget} />
        ))}
      </Grid>
      <MessageBoxFullPageDialog />
    </Grid>
  );
};
